var map = {
	"./halie-signature.png": 3826,
	"./rses-logo-small.png": 2854,
	"./rses-logo.png": 5637,
	"images/halie-signature.png": 3826,
	"images/rses-logo-small.png": 2854,
	"images/rses-logo.png": 5637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5187;